import React from 'react';
import { withBreadcrumb } from '@atlassian/commerce-telemetry/dispatch-hooks';
import { CC_LOADER } from '../../../common/constants/breadcrumb-names';
import * as FieldNames from '../../../common/constants/field-names';
import { FieldSkeleton, LabelSkeleton, LoadingForm } from './styled';
var NBSP = "\xA0";
var InputSkeleton = function InputSkeleton(_ref) {
  var gridArea = _ref.as;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      gridArea: gridArea
    }
  }, /*#__PURE__*/React.createElement(LabelSkeleton, {
    children: NBSP
  }), /*#__PURE__*/React.createElement(FieldSkeleton, {
    children: NBSP
  }));
};
var LoadingCreditCardWithoutBreadcrumb = function LoadingCreditCardWithoutBreadcrumb(_ref2) {
  var visible = _ref2.visible;
  return /*#__PURE__*/React.createElement(LoadingForm, {
    visible: visible
  }, /*#__PURE__*/React.createElement(InputSkeleton, {
    as: FieldNames.NUMBER
  }), /*#__PURE__*/React.createElement(InputSkeleton, {
    as: FieldNames.NAME
  }), /*#__PURE__*/React.createElement(InputSkeleton, {
    as: FieldNames.EXPIRY
  }), /*#__PURE__*/React.createElement(InputSkeleton, {
    as: FieldNames.CVC
  }));
};
export var LoadingCreditCard = withBreadcrumb(LoadingCreditCardWithoutBreadcrumb, CC_LOADER, {
  isForDevsOnly: true
});